import Image from './image';
import MediaComponent from './media-component';

export default class Background {
  backgroundColor?: string;
  message?: string;
  messageScrollSpeed?: number;
  images?: Image[];
  video?: MediaComponent | null;

  constructor(props: any) {
    if (!props) return;

    const {
      message,
      messageScrollSpeed,
      color,
      gradient,
      imagesCollection,
      video
    } = props;
    const tempColor = color || 'none';

    this.message = message;
    this.messageScrollSpeed = messageScrollSpeed || 0;
    this.backgroundColor = gradient
      ? `linear-gradient(78.28deg, ${tempColor} 19.39%, ${gradient} 95.87%)`
      : tempColor;
    this.images = imagesCollection?.items?.map(
      (image: any) => new Image(image)
    );
    this.video = video ? new MediaComponent(video) : null;
  }
}
